import { useFormContext } from 'react-hook-form';
import { WaitlistForm } from '@/features/public/waitlist/schemas/waitlistSchema.ts';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card.tsx';
import { TextInput } from '@/components/form/TextInput.tsx';
import TwoInputsRow from '@/components/form/ui/TwoInputsRow.tsx';
import { DateInput } from '@/components/form/DateInput.tsx';
import { Trash } from 'lucide-react';
import DangerIconButton from '@/components/buttons/DangerIconButton.tsx';

const WaitlistParticipantForm = ({
  index,
  remove,
}: {
  index: number;
  remove: (index: number) => void;
}) => {
  const {
    control,
    register,
    formState: { errors },
    watch,
  } = useFormContext<WaitlistForm>();

  const fillerType = watch('fillerType');

  const isParticipantFilling = fillerType === 'participant' && index === 0;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Uczestnik {index + 1}</CardTitle>
        {!isParticipantFilling && index !== 0 && (
          <DangerIconButton onClick={() => remove(index)}>
            <Trash />
          </DangerIconButton>
        )}
      </CardHeader>
      <CardContent className="space-y-4 p-4">
        <TwoInputsRow>
          <TextInput
            label="Imię"
            register={register(`participants.${index}.firstName`)}
            placeholder="Wpisz imię..."
            required
            error={errors.participants?.[index]?.firstName?.message}
            disabled={isParticipantFilling}
          />
          <TextInput
            label="Nazwisko"
            register={register(`participants.${index}.lastName`)}
            placeholder="Wpisz nazwisko..."
            required
            error={errors.participants?.[index]?.lastName?.message}
            disabled={isParticipantFilling}
          />
        </TwoInputsRow>
        <DateInput
          label="Data urodzenia"
          dateFieldName={`participants.${index}.birthDate`}
          control={control}
          required
          error={errors.participants?.[index]?.birthDate?.message}
          disabled={isParticipantFilling}
        />
      </CardContent>
    </Card>
  );
};

export default WaitlistParticipantForm;
